export default __webpack_public_path__ + "static/media/chemdivlogo.8bcb3a3e.webp";